import React, { useEffect, useRef, useState } from 'react';
import { IMG } from './shared';

const TILES = [
  {
    src: `${IMG}/academy/studio-duo.webp`,
    alt: 'Two operators recording a rental business podcast episode together',
    column: '1', row: '1 / span 2',
  },
  {
    src: `${IMG}/academy/mic-smoke.webp`,
    alt: 'Studio microphone lit in warm and cool stage light',
    column: '2', row: '1 / span 3',
  },
  {
    src: `${IMG}/academy/host-teal.webp`,
    alt: 'Host laughing while recording an operator training session',
    column: '1', row: '3 / span 1',
  },
  {
    src: `${IMG}/academy/convertible-couple.webp`,
    alt: 'Guests taking a selfie in a convertible rental car',
    column: '1', row: '4 / span 2',
  },
  {
    src: `${IMG}/academy/training-session.webp`,
    alt: 'Operator walking a teammate through fleet performance on a screen',
    column: '2', row: '4 / span 2',
  },
  {
    src: `${IMG}/academy/headphones-closeup.webp`,
    alt: 'Close-up of a guest speaker wearing studio headphones',
    column: '1', row: '6 / span 2',
  },
  {
    src: `${IMG}/academy/expo-floor.webp`,
    alt: 'Busy industry conference floor filled with attendees',
    column: '2', row: '6 / span 2',
  },
];

/** RentAcademy visual — photo collage tiles pour in on scroll. */
const AcademyCollage = () => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;
    if (typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return undefined;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} className="mpa-collage">
      {TILES.map((tile, index) => (
        <figure
          key={tile.src}
          className={`mpa-tile${visible ? ' mpa-liquid-in-x' : ' mpa-hidden'}`}
          style={{
            gridColumn: tile.column,
            gridRow: tile.row,
            ...(visible ? { animationDelay: `${index * 110}ms` } : {}),
          }}
        >
          <img src={tile.src} alt={tile.alt} loading="lazy" />
        </figure>
      ))}
    </div>
  );
};

export default AcademyCollage;
